/* eslint-disable @typescript-eslint/no-var-requires */
const hiayConfig = require('hiya-common/config.js')
const package = require('./package.json')

module.exports = {
  project: package.name,
  devPort: 7200,
  devStaticPort: 7201,
  tracingOrigins: [
    'https://version-chat-web-test.youyisia.com/', // 根据H5 host来修改
    'https://version-hiya-web.higochat.net/', // 根据H5 host来修改
  ],
  ...hiayConfig,
}
